export const STORE_RECONCILIATION_STATUS = {
  ABERTO: "ABERTO",
  AGUARDANDO: "AGUARDANDO",
  FECHADO: "FECHADO",
} as const;

export const DEPOSIT_STATUS = {
  PENDING: "PENDING",
  RECONCILED: "RECONCILED",
} as const;

export const DEPOSIT_STATUS_FILTER = {
  PENDING: "PENDING",
  IN_DRAFT: "IN_DRAFT",
  RECONCILED: "RECONCILED",
} as const;

export type DepositStatusFilter = (typeof DEPOSIT_STATUS_FILTER)[keyof typeof DEPOSIT_STATUS_FILTER];

export const BATCH_STATUS = {
  ACTIVE: "ACTIVE",
  UNDONE: "UNDONE",
} as const;

export const DEPOSIT_ORIGIN = {
  AUTO: "AUTO",
  MANUAL: "MANUAL",
} as const;
